export const getErrorMessage = error => {
    const message = error.response?.data ?? error.message;
    const isObject = typeof message === 'object';

    return isObject ? JSON.parse(message) : message;
};
